require("./common/init").init();
require("./register-to-vote/init").init();